// toolbar.js
// Clean, professional toolbar

import { useState } from "react";
import { DraggableNode } from "./draggableNode";

export const PipelineToolbar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const containerStyle = {
    background: "#ffffff",
    borderBottom: "1px solid #e2e8f0",
    padding: isCollapsed ? "12px 24px" : "16px 24px",
    transition: "all 0.2s ease",
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: isCollapsed ? "0" : "16px",
  };

  const titleStyle = {
    fontSize: "15px",
    fontWeight: "600",
    color: "#0f172a",
    letterSpacing: "-0.01em",
  };

  const toggleButtonStyle = {
    background: "transparent",
    border: "1px solid #e2e8f0",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    color: "#64748b",
    transition: "all 0.15s ease",
  };

  const contentStyle = {
    display: isCollapsed ? "none" : "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
  };

  const sectionStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  };

  const sectionTitleStyle = {
    fontSize: "11px",
    fontWeight: "600",
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: "2px",
  };

  const nodeGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "8px",
  };

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <div style={titleStyle}>Nodes</div>
        <button
          style={toggleButtonStyle}
          onClick={() => setIsCollapsed(!isCollapsed)}
          onMouseEnter={(e) => {
            e.target.style.background = "#f8fafc";
            e.target.style.borderColor = "#cbd5e1";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
            e.target.style.borderColor = "#e2e8f0";
          }}
        >
          {isCollapsed ? "Show" : "Hide"}
        </button>
      </div>

      <div style={contentStyle}>
        <div style={sectionStyle}>
          <div style={sectionTitleStyle}>Input/Output</div>
          <div style={nodeGridStyle}>
            <DraggableNode type="customInput" label="Input" />
            <DraggableNode type="customOutput" label="Output" />
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionTitleStyle}>Processing</div>
          <div style={nodeGridStyle}>
            <DraggableNode type="llm" label="LLM" />
            <DraggableNode type="text" label="Text" />
            <DraggableNode type="filter" label="Filter" />
            <DraggableNode type="transform" label="Transform" />
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionTitleStyle}>Integration</div>
          <div style={nodeGridStyle}>
            <DraggableNode type="conditional" label="Conditional" />
            <DraggableNode type="database" label="Database" />
            <DraggableNode type="api" label="API Call" />
          </div>
        </div>
      </div>
    </div>
  );
};
